<template>
    <div class="page">
        <!-- 顶部区域 -->
        <div class="header">
            <div class="header-bg">
                <div class="header-content">
                    <div class="logo-section">
                        <img class="logo-icon" src="./assets/img/FigmaDDSSlicePNGe909db0921cf6fdf268e6d7557656c70.png"
                            alt="logo" />
                        <span class="site-title">虹猫AI</span>
                    </div>
                    <div class="user-section">
                        <!-- 下载客户端按钮 -->
                        <div class="download-client-section" v-if="userInfo.id && userInfo.expired">
                            <div class="download-client-btn" @click="showDownloadModal">
                                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <polyline points="7,10 12,15 17,10" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span>下载客户端</span>
                            </div>
                        </div>

                        <!-- 会员信息 -->
                        <div v-if="userInfo.id" class="membership-info">
                            <div v-if="!userInfo.expired" class="membership-action">
                                <!--                                <div class="membership-badge free">
                                    <span class="membership-label">免费用户</span>
                                </div>-->
                                <div class="purchase-btn" @click="showActivationModal">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span>体验码</span>
                                </div>
                            </div>
                            <div v-if="!userInfo.expired || userInfo.orderType === 'try'" class="membership-action">
                                <!--                                <div class="membership-badge free">
                                    <span class="membership-label">免费用户</span>
                                </div>-->
                                <div class="purchase-btn" @click="showPurchaseModal">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                    </svg>
                                    <span>购买套餐</span>
                                </div>
                            </div>
                            <div v-if="userInfo.expired" class="membership-status">
                                <div class="membership-badge vip">
                                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z"
                                            fill="currentColor" />
                                    </svg>
                                    <span class="membership-label">{{ userInfo.pkg }}</span>
                                </div>
                                <div class="expiry-info">
                                    <span class="expiry-label">到期时间</span>
                                    <span class="expiry-date">{{ userInfo.expired }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 用户信息或登录按钮 -->
                        <div v-if="userInfo.id" class="user-info-section" @mouseenter="showUserMenu = true"
                            @mouseleave="showUserMenu = false">
                            <div class="user-avatar-wrapper">
                                <img v-if="userInfo.avatarUrl" :src="userInfo.avatarUrl" :alt="userInfo.nickName"
                                    class="user-avatar" />
                                <div v-else class="user-avatar-default">
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M20 21V19C20 17.9391 19.5786 16.9217 18.8284 16.1716C18.0783 15.4214 17.0609 15 16 15H8C6.93913 15 5.92172 15.4214 5.17157 16.1716C4.42143 16.9217 4 17.9391 4 19V21"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <circle cx="12" cy="7" r="4" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                            <div class="user-info-text">
                                <div class="user-nickname">{{ userInfo.nickName }}</div>
                                <div class="user-id">邀请码: {{ userInfo.code }}</div>
                            </div>
                            <div class="user-menu-btn">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 9L12 15L18 9" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>

                            <!-- 用户菜单 -->
                            <div v-if="showUserMenu" class="user-menu">
                                <div class="user-menu-item logout" @click="logout">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <polyline points="16,17 21,12 16,7" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="21" y1="12" x2="9" y2="12" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    <span>退出登录</span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="login-btn" @click="toLogin">登录</div>
                    </div>
                </div>
                <div class="header-bg1"></div>

                <!-- 主标题区域 -->
                <div class="main-content-area">
                    <div class="main-content-area-content">
                        <div class="title-section">
                            <h1 class="main-title">虹猫 素材网</h1>
                            <img class="image_13" referrerpolicy="no-referrer"
                                src="./assets/img/FigmaDDSSlicePNGfed3ea6f378441db0fbb23d39ee7c0a1.png" />
                            <span class="text_43">下载的不止是素材，是故事的开始！</span>
                        </div>

                        <!-- 角色展示区域 -->
                        <div class="characters-container">
                            <img src="./assets/img/FigmaDDSSlicePNG6fcc2a468bc54aa0a3d966eddbfce04d.png" alt="" />
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <div class="content-box">
            <div class="content-body">
                <!-- 素材类型和分类联合导航栏 -->
                <div class="combined-nav">
                    <!-- 素材类型筛选栏 (20%) -->
                    <div class="material-type-nav">
                        <div class="material-type-item" :class="{ 'active': currentMaterialType.value === item.value }"
                            v-for="item in materialTypeList" :key="item.value" @click="handleMaterialTypeChange(item)">
                            <div class="material-type-icon">
                                <i v-if="item.value === 'character'" class="el-icon-user"></i>
                                <i v-else-if="item.value === 'scene'" class="el-icon-picture"></i>
                                <i v-else-if="item.value === 'prop'" class="el-icon-box"></i>
                                <i v-else-if="item.value === 'vfx'" class="el-icon-magic-stick"></i>
                            </div>
                            <span class="material-type-label">{{ item.label }}</span>
                        </div>
                    </div>

                    <!-- 分类标签栏 (右侧占剩余空间) -->
                    <div v-if="filteredCategoryList.length > 0" class="category-nav-wrapper">
                        <!-- 左侧滚动按钮 -->
                        <div class="scroll-btn scroll-btn-left" :class="{ disabled: !canScrollLeft }"
                            @click="scrollCategories('left')">
                            <i class="el-icon-arrow-left"></i>
                        </div>

                        <!-- 分类导航区域 -->
                        <div class="category-nav" ref="categoryNav" @mousedown="startDrag" @mousemove="onDrag"
                            @mouseup="endDrag" @mouseleave="endDrag" @touchstart="startDrag" @touchmove="onDrag"
                            @touchend="endDrag">
                            <div v-for="item in filteredCategoryList" :key="item.id" class="category-item"
                                :class="{ 'active': currentCategory.id === item.id }"
                                @click="handleCategoryClick(item, $event)">
                                <img class="category-avatar" :src="getThumbnailUrl(item.cover)" :alt="item.categoryName"
                                    loading="lazy" @error="onCategoryImageError($event, item.cover)" />
                                <span class="category-label">{{ item.categoryName }}（{{ item.materialCount }}）</span>
                            </div>
                        </div>

                        <!-- 右侧滚动按钮 -->
                        <div class="scroll-btn scroll-btn-right" :class="{ disabled: !canScrollRight }"
                            @click="scrollCategories('right')">
                            <i class="el-icon-arrow-right"></i>
                        </div>
                    </div>
                </div>

                <!-- 搜索栏和工具栏 -->
                <div class="toolbar">
                    <div class="search-box">
                        <img class="search-icon" src="./assets/img/FigmaDDSSlicePNG3f77516085858d2a556846ce828353c7.png"
                            alt="搜索" />
                        <input type="text" placeholder="搜索" v-model="searchTitle" class="search-input"
                            @keydown.enter="reloadData" @change="reloadData" />
                    </div>
                    <!--                    <div class="toolbar-right">
                        <div class="filter-btn">已选择4个符号</div>
                        <div class="download-btn" style="display: flex">
                            <img src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png" alt="">
                            <span style="margin-left: 3px;">下载</span>
                        </div>
                        <div class="clear-btn">取消全选</div>
                    </div>-->
                </div>

                <!-- 卡片网格区域 -->
                <div class="cards-grid">
                    <div v-for="item in cardData" :key="`${page.index}-${item.id}`" class="card-item"
                        @click="showModal(item)">
                        <div class="card-container">
                            <div class="card-image-wrapper">
                                <div class="download-overlay" v-if="hasLogin" @click.stop="downloadSource(item)">
                                    <img class="download-icon"
                                        src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
                                        alt="下载" />
                                </div>

                                <!-- 图片加载占位符 -->
                                <div v-show="['loading'].includes(getImageLoadingState(item.id))"
                                    class="image-placeholder">
                                    <div class="placeholder-shimmer"></div>
                                </div>

                                <!-- 图片加载失败占位符 -->
                                <div v-show="getImageLoadingState(item.id) === 'error'" class="image-error">
                                    <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <rect x="3" y="3" width="18" height="18" rx="2" ry="2" stroke="currentColor"
                                            stroke-width="2" />
                                        <circle cx="8.5" cy="8.5" r="1.5" stroke="currentColor" stroke-width="2" />
                                        <polyline points="21,15 16,10 5,21" stroke="currentColor" stroke-width="2" />
                                    </svg>
                                    <p>图片加载失败</p>
                                </div>

                                <!-- 实际图片 -->
                                <img class="card-image"
                                    :class="{ 'loaded': getImageLoadingState(item.id) === 'loaded' }"
                                    :src="getThumbnailUrl(item.mainImage)" :data-item-id="item.id" :alt="item.title"
                                    loading="lazy" @load="onImageLoad(item.id)" @error="onImageError(item.id, $event)"
                                    @loadstart="onImageLoadStart(item.id)" ref="cardImage" />
                            </div>
                            <div class="card-header">
                                <div class="card-info">
                                    <div class="card-title-row">
                                        <h3 class="card-title">{{ item.title }}</h3>
                                        <!--                                        <div class="card-tag">
                                            <span class="tag-label"># {{ item.tag }}</span>
                                        </div>-->
                                    </div>
                                    <p class="card-meta">{{ item.createTime }} {{ `${(item.views || 0) > 0 ? ` ·
                                        ${item.views} 人围观` : ''}` }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="cardData.length === 0" class="cards-empty">
                    <p>暂无数据</p>
                </div>

                <!-- 详情弹窗 -->
                <transition name="modal" appear>
                    <div v-if="modalVisible" class="modal-overlay" @click="hideModal">
                        <div class="modal-container" @click.stop>
                            <!-- 弹窗头部 -->
                            <div class="modal-header">
                                <div class="modal-header-left">
                                    <h2 class="modal-title">{{ currentItem.title }}</h2>
                                    <div class="modal-info">
                                        <!-- <div class="modal-tag">
                                            <span># {{ currentItem.tag }}</span>
                                        </div> -->
                                        <div class="modal-meta" v-if="currentItem.views">
                                            {{ currentItem.date }} · {{ currentItem.views }}人围观
                                        </div>
                                    </div>
                                </div>
                                <div class="modal-header-actions">
                                    <div class="modal-download-btn" v-if="hasLogin"
                                        @click.stop="downloadSource(currentItem)">
                                        <img src="./assets/img/FigmaDDSSlicePNG7ac7c833b1ac15280ee0df46fbb4de1f.png"
                                            alt="下载">
                                        <span>下载</span>
                                    </div>
                                    <div class="modal-close-btn" @click="hideModal">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                            <path d="M18 6L6 18" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                            <path d="M6 6L18 18" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </div>

                            <!-- 弹窗主内容区域 -->
                            <div class="modal-content">
                                <div class="modal-image-container">
                                    <!-- 预览图 -->
                                    <img class="modal-image"
                                        :src="getOptimizedImageUrl(currentItem.mainImage, 'preview')"
                                        :alt="currentItem.title" />
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <!-- 分页组件 -->
                <div class="pagination">
                    <el-pagination background layout="total, prev, pager, next" @current-change="handleCurrentChange"
                        :current-page="page.index" :page-size="page.limit" :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </div>

        <!-- 套餐购买弹窗 -->
        <transition name="purchase-modal" appear>
            <div v-if="purchaseModalVisible" class="purchase-modal-overlay"
                @click="hidePurchaseModal(); resetPurchaseData()">
                <div class="purchase-modal-container" @click.stop>
                    <!-- 弹窗头部 -->
                    <div class="purchase-modal-header">
                        <div class="purchase-modal-title-section">
                            <h2 class="purchase-modal-title">{{ purchaseStep === 1 ? '选择您的专属套餐' : '填写邀请码' }}</h2>
                            <p class="purchase-modal-subtitle">{{ purchaseStep === 1 ? '解锁更多精彩内容，享受VIP特权' :
                                '请填写邀请码，享受更多优惠' }}</p>
                        </div>
                        <div class="purchase-modal-close" @click="hidePurchaseModal(); resetPurchaseData()">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>

                    <!-- 步骤1：套餐列表 -->
                    <div v-if="purchaseStep === 1" class="purchase-modal-content">
                        <div class="packages-grid">
                            <div v-for="(pkg, index) in packages" :key="index" class="package-card"
                                :class="{ 'popular': pkg.isPopular, 'selected': selectedPackage === pkg.id }"
                                @click="selectPackage(pkg.id)">

                                <!-- 推荐标签 -->
                                <div v-if="pkg.isPopular" class="popular-badge">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 2L15.09 8.26L22 9L17 14L18.18 21L12 17.77L5.82 21L7 14L2 9L8.91 8.26L12 2Z"
                                            fill="currentColor" />
                                    </svg>
                                    <span>推荐</span>
                                </div>

                                <!-- 套餐信息 -->
                                <div class="package-info">
                                    <div class="package-name">{{ pkg.name }}</div>
                                    <div class="package-duration">{{ pkg.duration }}天</div>
                                    <div class="package-price">
                                        <span class="currency">¥</span>
                                        <span class="amount" v-if="pkg.discount > 0">{{ Math.round(pkg.price *
                                            (pkg.discount / 10)) }}</span>
                                        <span class="amount" v-else>{{ pkg.price }}</span>
                                        <span v-if="pkg.discount > 0" class="original-price">¥{{ pkg.price }}</span>
                                    </div>
                                    <div v-if="pkg.discount" class="package-discount">限时 {{ pkg.discount }} 折</div>
                                </div>

                                <!-- 套餐描述 -->
                                <div class="package-features">
                                    <p class="package-description">{{ pkg.description }}</p>
                                </div>

                                <!-- 选择指示器 -->
                                <div class="package-selector">
                                    <div class="selector-radio" :class="{ 'selected': selectedPackage === pkg.id }">
                                        <div class="radio-dot"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 步骤2：邀请码填写界面 -->
                    <div v-else-if="purchaseStep === 2" class="purchase-modal-content invitation-step">
                        <!-- 选中的套餐信息显示 -->
                        <div class="selected-package-info">
                            <div class="package-summary">
                                <div class="summary-item">
                                    <span class="summary-label">套餐:</span>
                                    <span class="summary-value">{{ selectedPackageInfo?.name || '' }}</span>
                                </div>
                                <div class="summary-item">
                                    <span class="summary-label">时长:</span>
                                    <span class="summary-value">{{ selectedPackageInfo?.duration || '' }}天</span>
                                </div>
                                <div class="summary-item">
                                    <span class="summary-label">金额:</span>
                                    <span class="summary-value price">¥{{ selectedPackagePrice }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 邀请码输入区域 -->
                        <div class="invitation-code-section">
                            <div class="invitation-label">
                                <h3>邀请码 <span class="required">*</span></h3>
                                <p class="invitation-description">请填写邀请码以完成购买</p>
                            </div>
                            <div class="invitation-input-wrapper">
                                <input type="text" v-model="invitationCode" placeholder="请输入邀请码"
                                    class="invitation-input" />
                            </div>
                        </div>
                    </div>

                    <!-- 弹窗底部 -->
                    <div class="purchase-modal-footer">
                        <!-- 步骤1：选择套餐的底部 -->
                        <template v-if="purchaseStep === 1">
                            <div class="payment-info">
                                <div class="total-price">
                                    <span class="total-label">总计:</span>
                                    <span class="total-amount">¥{{ selectedPackagePrice }}</span>
                                </div>
                                <div class="payment-methods">
                                    <span class="payment-label">支持:</span>
                                    <div class="payment-icons">
                                        <!-- <div class="payment-icon wechat">微信支付</div> -->
                                        <div class="payment-icon alipay active">支付宝支付</div>
                                    </div>
                                </div>
                            </div>
                            <div class="purchase-actions">
                                <button class="purchase-btn-primary" @click="purchasePackage"
                                    :disabled="selectedPackage === null">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                    </svg>
                                    下一步
                                </button>
                            </div>
                        </template>

                        <!-- 步骤2：填写邀请码的底部 -->
                        <template v-else-if="purchaseStep === 2">
                            <div class="step2-actions">
                                <button class="purchase-btn-secondary" @click="backToStepOne">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M19 12H5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M12 19L5 12L12 5" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                    返回
                                </button>
                                <button class="purchase-btn-primary" @click="confirmPayment"
                                    :disabled="!invitationCode || invitationCode.trim() === ''">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                    </svg>
                                    确认支付
                                </button>
                            </div>
                        </template>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 下载客户端弹窗 -->
        <transition name="download-modal" appear>
            <div v-if="downloadModalVisible" class="download-modal-overlay" @click="hideDownloadModal">
                <div class="download-modal-container" @click.stop>
                    <!-- 弹窗头部 -->
                    <div class="download-modal-header">
                        <div class="download-modal-title-section">
                            <h2 class="download-modal-title">下载虹猫简笔画客户端</h2>
                            <p class="download-modal-subtitle">专业的简笔画创作工具，让创意触手可及</p>
                        </div>
                        <div class="download-modal-close" @click="hideDownloadModal">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>

                    <!-- 弹窗内容 -->
                    <div class="download-modal-content">
                        <!-- 客户端特性介绍 -->
                        <div class="client-features">
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2"
                                            fill="none" />
                                        <path d="M7 15L10 9L13 15" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" fill="none" />
                                        <line x1="8.2" y1="12.8" x2="11.8" y2="12.8" stroke="currentColor"
                                            stroke-width="2" stroke-linecap="round" />
                                        <line x1="16" y1="11" x2="16" y2="15" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" />
                                        <circle cx="16" cy="9" r="1" fill="currentColor" />
                                    </svg>
                                </div>
                                <div class="feature-text">
                                    <h4>AI生成</h4>
                                    <p>场景道具图片智能生成</p>
                                </div>
                            </div>
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                        <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="feature-text">
                                    <h4>丰富素材库</h4>
                                    <p>海量简笔画素材，分类齐全</p>
                                </div>
                            </div>
                            <div class="feature-item">
                                <div class="feature-icon">
                                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M17 3C17 3 21 7 21 12C21 17 17 21 12 21C7 21 3 17 3 12C3 7 7 3 12 3C15 3 17 3 17 3Z"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M9 12L11 14L15 10" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="feature-text">
                                    <h4>本地素材导入</h4>
                                    <p>支持导入本地素材，随时随地创作</p>
                                </div>
                            </div>

                        </div>

                        <!-- 版本信息 -->
                        <div class="version-info">
                            <div class="version-row">
                                <div class="version-item">
                                    <span class="version-label">当前版本:</span>
                                    <span class="version-value">{{ clientVersionInfo ? "v" +
                                        clientVersionInfo.versionName
                                        :
                                        'v1.2.0'
                                    }}</span>
                                </div>
                                <div class="version-item">
                                    <span class="version-label">更新时间:</span>
                                    <span class="version-value">{{ clientVersionInfo ?
                                        formatDate(clientVersionInfo.updateTime) :
                                        '--' }}</span>
                                </div>
                            </div>
                        </div>

                        <!-- 下载选项 -->
                        <div class="download-options">
                            <div v-for="platform in availablePlatforms" :key="platform" class="download-option"
                                @click="downloadClient(platform)">
                                <div class="option-icon">
                                    <!-- Windows 图标 -->
                                    <svg v-if="platform === 'windows'" width="32" height="32" viewBox="0 0 24 24"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 6H20V18H4V6Z" stroke="currentColor" stroke-width="2" />
                                        <path d="M7 9V15" stroke="currentColor" stroke-width="2" />
                                        <path d="M11 9V15" stroke="currentColor" stroke-width="2" />
                                        <path d="M15 9V15" stroke="currentColor" stroke-width="2" />
                                    </svg>
                                    <!-- Mac 图标 -->
                                    <svg v-else-if="platform === 'mac'" width="32" height="32" viewBox="0 0 24 24"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M18.71 8.21C17.64 7.38 16.29 6.88 14.85 6.88C13.43 6.88 12.09 7.37 11.03 8.19C10.57 7.42 9.91 6.79 9.12 6.37C8.33 5.95 7.43 5.74 6.53 5.76C5.63 5.78 4.74 6.04 3.97 6.5C3.2 6.96 2.58 7.62 2.18 8.41C1.78 9.2 1.61 10.09 1.7 10.98C1.79 11.87 2.13 12.71 2.68 13.41L8.21 20.74C8.6 21.26 9.16 21.61 9.79 21.72C10.42 21.83 11.07 21.69 11.6 21.32L12 21.03L12.4 21.32C12.93 21.69 13.58 21.83 14.21 21.72C14.84 21.61 15.4 21.26 15.79 20.74L21.32 13.41C21.87 12.71 22.21 11.87 22.3 10.98C22.39 10.09 22.22 9.2 21.82 8.41C21.42 7.62 20.8 6.96 20.03 6.5C19.26 6.04 18.37 5.78 17.47 5.76C16.57 5.74 15.67 5.95 14.88 6.37C14.09 6.79 13.43 7.42 12.97 8.19"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path d="M12 2V6" stroke="currentColor" stroke-width="1.5"
                                            stroke-linecap="round" />
                                    </svg>
                                    <!-- Linux 图标 -->
                                    <svg v-else-if="platform === 'linux'" width="32" height="32" viewBox="0 0 24 24"
                                        fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 3C10.9 3 10 3.9 10 5C10 5.8 10.4 6.5 11 6.9V8C11 8.6 10.6 9 10 9C9.4 9 9 9.4 9 10V14C9 14.6 9.4 15 10 15H14C14.6 15 15 14.6 15 14V10C15 9.4 14.6 9 14 9C13.4 9 13 8.6 13 8V6.9C13.6 6.5 14 5.8 14 5C14 3.9 13.1 3 12 3Z"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <path
                                            d="M9 15C9 16.1 8.1 17 7 17C5.9 17 5 17.9 5 19V21M15 15C15 16.1 15.9 17 17 17C18.1 17 19 17.9 19 19V21"
                                            stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <div class="option-info">
                                    <h3>{{ getPlatformName(platform) }}</h3>
                                    <p>{{ getPlatformDesc(platform) }}</p>
                                </div>
                                <div class="download-arrow">
                                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                        <polyline points="7,10 12,15 17,10" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                        <line x1="12" y1="15" x2="12" y2="3" stroke="currentColor" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </transition>

        <!-- 版权信息 -->
        <div class="copyright">
            Copyright 2025 河北虹猫创意网络科技有限公司. All Rights Reserved 冀ICP备2025106965号-1
        </div>

        <!-- 扫码支付弹窗 -->
        <transition name="payment-modal" appear>
            <div v-if="paymentModalVisible" class="payment-modal-overlay" @click="hidePaymentModal">
                <div class="payment-modal-container" @click.stop>
                    <!-- 弹窗头部 -->
                    <div class="payment-modal-header">
                        <div class="payment-modal-title-section">
                            <h2 class="payment-modal-title">支付宝扫码支付</h2>
                            <p class="payment-modal-subtitle">请使用支付宝扫描下方二维码完成支付</p>
                        </div>
                        <div class="payment-modal-close" @click="hidePaymentModal">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>

                    <!-- 弹窗内容 -->
                    <div class="payment-modal-content">
                        <!-- 订单信息 -->
                        <div class="payment-order-info">
                            <div class="order-item">
                                <span class="order-label">套餐:</span>
                                <span class="order-value">{{ selectedPackageInfo?.name || '' }}</span>
                            </div>
                            <div class="order-item">
                                <span class="order-label">时长:</span>
                                <span class="order-value">{{ selectedPackageInfo?.duration || '' }}天</span>
                            </div>
                            <div class="order-item">
                                <span class="order-label">金额:</span>
                                <span class="order-value price">¥{{ selectedPackagePrice }}</span>
                            </div>
                            <div class="order-item">
                                <span class="order-label">邀请码:</span>
                                <span class="order-value invitation-code">{{ invitationCode || '无' }}</span>
                            </div>
                        </div>

                        <!-- 二维码区域 -->
                        <div class="payment-qrcode-area">
                            <div v-if="paymentLoading" class="qrcode-loading">
                                <div class="loading-spinner"></div>
                                <p>正在生成支付二维码...</p>
                            </div>
                            <div v-else-if="paymentQrCode" class="qrcode-container">
                                <img :src="paymentQrCode" alt="支付二维码" class="qrcode-image">
                                <p class="qrcode-tip">请使用支付宝扫描二维码</p>
                            </div>
                            <div v-else class="qrcode-error">
                                <p>二维码生成失败，请重试</p>
                                <button class="retry-btn" @click="generatePaymentQrCode">重新生成</button>
                            </div>
                        </div>

                        <!-- 支付状态 -->
                        <div class="payment-status">
                            <div v-if="paymentPolling" class="status-polling">
                                <div class="status-icon">
                                    <div class="pulse-ring"></div>
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M12 2V6M12 18V22M4.93 4.93L7.76 7.76M16.24 16.24L19.07 19.07M2 12H6M18 12H22M4.93 19.07L7.76 16.24M16.24 7.76L19.07 4.93"
                                            stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" />
                                    </svg>
                                </div>
                                <p>等待支付中...</p>
                            </div>
                        </div>
                    </div>

                    <!-- 弹窗底部 -->
                    <div class="payment-modal-footer">
                        <button class="payment-cancel-btn" @click="hidePaymentModal">取消支付</button>
                        <button class="payment-refresh-btn" @click="generatePaymentQrCode" :disabled="paymentLoading">
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 4V10H7" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M23 20V14H17" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10M23 14L18.36 18.36A9 9 0 0 1 3.51 15"
                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                            刷新二维码
                        </button>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 体验码激活弹窗 -->
        <transition name="activation-modal" appear>
            <div v-if="activationModalVisible" class="activation-modal-overlay" @click="hideActivationModal">
                <div class="activation-modal-container" @click.stop>
                    <!-- 弹窗头部 -->
                    <div class="activation-modal-header">
                        <div class="activation-modal-title-section">
                            <h2 class="activation-modal-title">激活体验码</h2>
                            <p class="activation-modal-subtitle">请输入您的体验码来激活VIP权限</p>
                        </div>
                        <div class="activation-modal-close" @click="hideActivationModal">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                                <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>

                    <!-- 弹窗内容 -->
                    <div class="activation-modal-content">
                        <div class="activation-form">
                            <div class="activation-input-group">
                                <label class="activation-label">体验码</label>
                                <input v-model="activationCode" type="text" class="activation-input"
                                    placeholder="请输入体验码" maxlength="50" @keyup.enter="activateCode" />
                                <div class="activation-input-hint">请输入有效的体验码，激活后即可享受VIP权限</div>
                            </div>
                        </div>
                    </div>

                    <!-- 弹窗底部 -->
                    <div class="activation-modal-footer">
                        <button class="activation-cancel-btn" @click="hideActivationModal">取消</button>
                        <button class="activation-confirm-btn" @click="activateCode"
                            :disabled="!activationCode.trim() || activationLoading">
                            <span v-if="activationLoading">激活中...</span>
                            <span v-else>激活</span>
                        </button>
                    </div>
                </div>
            </div>
        </transition>

        <!-- 支付结果提示弹窗 -->
        <transition name="result-modal" appear>
            <div v-if="paymentResultVisible" class="result-modal-overlay" @click="hidePaymentResult">
                <div class="payment-result-container" @click.stop>
                    <div class="payment-result-content">
                        <!-- 成功状态 -->
                        <div v-if="paymentResult === 'success'" class="result-success">
                            <div class="result-icon success">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            </div>
                            <h3 class="result-title">支付成功</h3>
                            <p class="result-message">恭喜您！VIP套餐已开通成功</p>
                        </div>

                        <!-- 失败状态 -->
                        <div v-else-if="paymentResult === 'failed'" class="result-failed">
                            <div class="result-icon failed">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                                    <line x1="15" y1="9" x2="9" y2="15" stroke="currentColor" stroke-width="2" />
                                    <line x1="9" y1="9" x2="15" y2="15" stroke="currentColor" stroke-width="2" />
                                </svg>
                            </div>
                            <h3 class="result-title">支付失败</h3>
                            <p class="result-message">支付过程中出现问题，请重试</p>
                        </div>

                        <!-- 取消状态 -->
                        <div v-else-if="paymentResult === 'cancelled'" class="result-cancelled">
                            <div class="result-icon cancelled">
                                <svg width="48" height="48" viewBox="0 0 24 24" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2" />
                                    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" stroke="currentColor"
                                        stroke-width="2" />
                                </svg>
                            </div>
                            <h3 class="result-title">支付已取消</h3>
                            <p class="result-message">您已取消本次支付</p>
                        </div>
                    </div>

                    <div class="payment-result-footer">
                        <button class="result-btn primary" @click="hidePaymentResult">确定</button>
                    </div>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
import { storage } from '@/utils/Storage';
import { uuid } from '@/utils/uuid_utils';
import * as api from '@/api/auth'
import http from '@/utils/axiosProxy.js'
// 导入 Swiper (Swiper 6 简化方式)
import 'swiper/swiper-bundle.css'
// 由于Swiper 6 Vue组件可能有兼容性问题，我们暂时移除Swiper，恢复原来的滚动实现
export default {
    name: 'index',
    components: {
    },
    data() {
        return {
            cardData: [],
            modalVisible: false,
            currentItem: null,
            // 用户信息
            userInfo: {
                id: null, // 用户ID，用于判断是否登录
                unionid: null,
                avatarUrl: null,
                nickName: null,
                code: null,
                phone: null,
                isMember: false, // 是否为会员
                membershipExpiry: '', // 会员到期时间
                membershipType: 'VIP' // 会员类型
            },
            purchaseModalVisible: false,
            selectedPackage: null,
            packages: [],
            sessionId: null,
            // 购买流程控制
            purchaseStep: 1, // 1: 选择套餐, 2: 填写邀请码
            invitationCode: '', // 邀请码
            checkLoginTimer: null,
            showUserMenu: false,
            page: {
                index: 1,
                limit: 12,
                total: 0
            },
            paymentModalVisible: false,
            paymentQrCode: null,
            paymentLoading: false,
            paymentPolling: false,
            paymentResultVisible: false,
            paymentResult: null,
            selectedPackageInfo: null,
            pollInterval: null,
            // 体验码激活相关
            activationModalVisible: false,
            activationCode: '',
            activationLoading: false,
            downloadModalVisible: false, // 下载客户端弹窗显示状态
            clientVersionInfo: null, // 客户端版本信息
            categoryList: [],
            currentCategory: {},
            // 素材类型相关
            materialTypeList: [
                { label: '角色', value: 'character' },
                { label: '道具', value: 'prop' },
                { label: '场景', value: 'scene' },
                { label: '特效', value: 'vfx' }
            ],
            currentMaterialType: { label: '角色', value: 'character' },
            searchTitle: null,
            orderId: null,
            token: storage.getToken(),
            // 图片优化相关
            imageLoadingStates: new Map(), // 记录图片加载状态
            intersectionObserver: null, // Intersection Observer实例
            preloadedPages: new Set(), // 已预加载的页面
            imageConfig: {
                category: { width: 32, height: 32, quality: 80 },
                thumbnail: { width: 300, height: 200, quality: 75 },
                preview: { width: 800, height: 600, quality: 85 }
            },
            // 滚动和拖拽相关数据
            isDragging: false,
            dragStartX: 0,
            dragStartY: 0,
            dragThreshold: 5, // 拖拽阈值，超过此像素才算拖拽
            scrollStartX: 0,
            canScrollLeft: false,
            canScrollRight: false,
        }
    },
    computed: {
        selectedPackagePrice() {
            if (this.selectedPackage !== null) {
                const pkg = this.packages.find(p => p.id === this.selectedPackage);
                if (pkg) {
                    return pkg.discount > 0 ? Math.round(pkg.price * (pkg.discount / 10)) : pkg.price;
                }
            }
            return '0';
        },
        hasLogin() {
            return !!this.token
        },
        // 根据当前选择的素材类型过滤分类列表
        filteredCategoryList() {
            return this.categoryList.filter(category =>
                category.typeCode === this.currentMaterialType.value
            );
        },
        // 根据 downloadConfig 解析可用平台
        availablePlatforms() {
            if (!this.clientVersionInfo || !this.clientVersionInfo.downloadConfig) {
                return [];
            }
            // 使用逗号分割平台字符串
            const platforms = this.clientVersionInfo.downloadConfig.split(',').map(p => p.trim());
            return platforms.filter(p => ['windows', 'mac', 'linux'].includes(p));
        },
    },
    methods: {
        // ========== 滚动和拖拽相关方法 ==========
        startDrag(e) {
            this.isDragging = false;
            this.dragStartX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
            this.dragStartY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
            this.scrollStartX = this.$refs.categoryNav.scrollLeft;
        },

        onDrag(e) {
            if (this.dragStartX === 0) return;

            const currentX = e.type.includes('touch') ? e.touches[0].clientX : e.clientX;
            const currentY = e.type.includes('touch') ? e.touches[0].clientY : e.clientY;
            const deltaX = Math.abs(currentX - this.dragStartX);
            const deltaY = Math.abs(currentY - this.dragStartY);

            // 判断是否为拖拽
            if (deltaX > this.dragThreshold || deltaY > this.dragThreshold) {
                this.isDragging = true;

                // 水平拖拽
                if (deltaX > deltaY) {
                    e.preventDefault();
                    const scrollLeft = this.scrollStartX - (currentX - this.dragStartX);
                    this.$refs.categoryNav.scrollLeft = scrollLeft;
                    this.updateScrollButtons();
                }
            }
        },

        endDrag() {
            this.dragStartX = 0;
            this.dragStartY = 0;
            this.scrollStartX = 0;

            // 延迟重置拖拽状态，避免点击事件立即触发
            setTimeout(() => {
                this.isDragging = false;
            }, 100);
        },

        scrollCategories(direction) {
            const container = this.$refs.categoryNav;
            const scrollAmount = 400; // 每次滚动的距离（增加到400px）

            if (direction === 'left') {
                container.scrollLeft -= scrollAmount;
            } else {
                container.scrollLeft += scrollAmount;
            }

            // 延迟更新按钮状态，等待滚动完成
            setTimeout(() => {
                this.updateScrollButtons();
            }, 100);
        },

        updateScrollButtons() {
            this.$nextTick(() => {
                const container = this.$refs.categoryNav;
                if (container) {
                    this.canScrollLeft = container.scrollLeft > 0;
                    this.canScrollRight = container.scrollLeft < (container.scrollWidth - container.clientWidth);
                }
            });
        },

        handleCategoryClick(category, event) {
            // 如果正在拖拽，不触发点击事件
            if (this.isDragging) {
                event.preventDefault();
                return;
            }

            this.handleCategoryChange(category);
        },

        showModal(item) {
            this.currentItem = item;
            this.modalVisible = true;
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', this.handleKeyDown);
        },
        hideModal() {
            this.modalVisible = false;
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', this.handleKeyDown);
        },
        handleKeyDown(e) {
            if (e.key === 'Escape') {
                this.hideModal();
            }
        },
        showPurchaseModal() {
            // 重置所有购买相关数据
            this.selectedPackage = null;
            this.selectedPackageInfo = null;
            this.purchaseStep = 1;
            this.invitationCode = this.userInfo.invitationCode || '';

            // 显示弹窗
            this.purchaseModalVisible = true;
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', this.handlePurchaseKeyDown);
        },
        hidePurchaseModal() {
            this.purchaseModalVisible = false;
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', this.handlePurchaseKeyDown);
        },
        resetPurchaseData() {
            // 重置购买相关数据
            this.selectedPackage = null;
            this.selectedPackageInfo = null;
            this.purchaseStep = 1;
            this.invitationCode = '';
        },
        // ==================== 体验码激活相关方法 ====================
        showActivationModal() {
            this.activationCode = '';
            this.activationLoading = false;
            this.activationModalVisible = true;
            document.body.style.overflow = 'hidden';
            document.addEventListener('keydown', this.handleActivationKeyDown);
        },
        hideActivationModal() {
            this.activationModalVisible = false;
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', this.handleActivationKeyDown);
        },
        handleActivationKeyDown(e) {
            if (e.key === 'Escape') {
                this.hideActivationModal();
            }
        },
        async activateCode() {
            if (!this.activationCode.trim()) {
                this.$message.warning('请输入体验码');
                return;
            }

            this.activationLoading = true;
            try {
                // TODO: 这里需要调用实际的API接口来激活体验码
                const { code, message, data } = await api.createTryOrder(this.activationCode);
                if (code === 1000) {
                    if (data.success) {
                        this.$message.success(data.message);
                        this.initUserInfo();
                        this.hideActivationModal();
                    } else {
                        this.$message.error(data.message);
                    }
                } else {
                    this.$message.error(message);
                }
            } catch (error) {
                console.error('体验码激活失败:', error);
                this.initUserInfo();
                this.$message.error('体验码激活失败，请检查体验码是否正确');
            } finally {
                this.activationLoading = false;
            }
        },
        handlePurchaseKeyDown(e) {
            if (e.key === 'Escape') {
                this.hidePurchaseModal();
                // ESC关闭时重置数据
                this.resetPurchaseData();
            }
        },
        selectPackage(id) {
            this.selectedPackage = id;
        },
        purchasePackage() {
            if (this.selectedPackage === null) {
                this.$message.warning('请选择套餐');
                return;
            }

            this.selectedPackageInfo = this.packages.find(pkg => pkg.id === this.selectedPackage);
            this.purchaseStep = 2;
        },
        // 返回第一步
        backToStepOne() {
            this.purchaseStep = 1;
        },
        // 确认支付
        confirmPayment() {
            if (!this.invitationCode || this.invitationCode.trim() === '') {
                this.$message.warning('请填写邀请码');
                return;
            }
            this.hidePurchaseModal();
            this.paymentModalVisible = true;
            this.generatePaymentQrCode();
        },
        // 测试方法：切换会员状态
        toggleMembershipStatus() {
            this.userInfo.isMember = !this.userInfo.isMember;
        },
        async toLogin() {
            this.sessionId = uuid()
            let { code, data } = await api.getAuthUrl(this.sessionId);
            if (code === 1000) {
                const windowWidth = 500;
                const windowHeight = 800;
                const left = (window.screen.width - windowWidth) / 2;
                const top = (window.screen.height - windowHeight) / 2;
                window.open(data, '虹猫创意统一认证', `width=${windowWidth},height=${windowHeight},left=${left},top=${top},resizable=yes,scrollbars=yes,location=no,menubar=no,resizable=no,toolbar=no`)
                this.checkLoginTimer = setInterval(this.checkLoginStatus, 1000)
            } else {
                this.$message.error('获取认证配置失败！')

            }
        },
        async checkLoginStatus() {
            let { code, data } = await api.checkLoginStatus(this.sessionId)
            if (code === 1000 && data && data.token) {
                storage.setToken(data.token)
                this.token = data.token
                this.clearTimers();
                await this.initUserInfo();
                await this.initData();
            } else {
                // alert('登录失败！')
            }
        },
        async initUserInfo() {
            try {
                let { code, data } = await api.getUserInfo()
                if (code === 1000) {
                    storage.set('userinfo', data)
                    this.userInfo = data;
                    // this.userInfo.expired = JSON.parse(JSON.stringify(this.userInfo.extData));
                    this.clearTimers();
                    this.loadPkgs();
                } else {
                    this.$message.error('获取用户信息失败！');
                }
            } catch (e) {
                if (`${e.toString()}`.indexOf('401') > -1) {
                    storage.removeToken()
                }
            }

        },
        clearTimers() {
            if (this.checkLoginTimer) {
                clearInterval(this.checkLoginTimer)
            }
        },

        goToProfile() {
            // 实现跳转到个人中心逻辑
            console.log('跳转到个人中心');
        },
        goToOrders() {
            // 实现跳转到我的订单逻辑
            console.log('跳转到我的订单');
        },
        logout() {
            // 实现退出登录逻辑
            storage.removeToken();
            storage.remove('userinfo');
            window.location.reload();
            /*this.userInfo = {
                id: null,
                unionid: null,
                avatarUrl: null,
                nickName: null,
                code: null,
                phone: null,
                isMember: false,
                membershipExpiry: '2025-12-31',
                membershipType: 'VIP'
            };
            this.showUserMenu = false;
            console.log('退出登录成功');*/
        },
        async loadPkgs() {
            let { code, data } = await api.getPkgs()
            if (code === 1000) {
                this.packages = data;
            } else {
                this.$message.error('获取套餐信息失败！');
            }
        },
        async loadCategory() {
            // 临时不传递素材类型参数，使用原始API
            let { code, data } = await api.getCategory();
            if (code === 1000) {
                this.categoryList = data;

                // 根据当前选中的素材类型设置默认分类
                const filteredCategories = this.categoryList.filter(category =>
                    category.typeCode === this.currentMaterialType.value
                );

                if (filteredCategories.length > 0) {
                    this.currentCategory = filteredCategories[0];
                } else {
                    this.currentCategory = {};
                }
            } else {
                this.$message.error('获取分类失败！');
            }
        },
        async loadData(pageIndex = null, isPreload = false) {
            // 如果传入了页码，则使用传入的页码，否则使用当前的页码
            const currentPage = pageIndex !== null ? pageIndex : this.page.index;

            // 如果没有选中的分类，直接返回
            if (!this.currentCategory || !this.currentCategory.id) {
                if (!isPreload) {
                    this.cardData = [];
                    this.page.total = 0;
                    this.page.index = 1;
                    this.loading = false;
                }
                return;
            }

            if (!isPreload) {
                this.loading = true;
            }

            try {
                // 临时不传递素材类型参数
                let { code, data } = await api.getDataListByCategoryId(this.currentCategory.id, this.searchTitle, currentPage, this.page.limit);
                if (code === 1000) {
                    if (isPreload) {
                        // 预加载时只返回数据，不更新界面
                        return data;
                    }

                    this.cardData = data.records;
                    this.page.total = data.totalRow;
                    this.page.index = currentPage; // 更新当前页码

                    // 初始化图片加载状态
                    data.records.forEach(item => {
                        this.setImageLoadingState(item.id, 'ready');
                    });

                    // 页面渲染完成后设置懒加载观察者
                    this.$nextTick(() => {
                        this.setupLazyLoading();
                        // 更新滚动按钮状态
                        this.updateScrollButtons();
                    });
                } else {
                    this.$message.error('获取素材失败！');
                }
            } catch (error) {
                console.error('加载数据失败:', error);
                this.$message.error('网络错误，请重试！');
                // 如果是网络错误，可以在这里添加重试逻辑
            } finally {
                if (!isPreload) {
                    this.loading = false;
                }
            }
        },
        // 处理页码改变
        handleCurrentChange(pageIndex) {
            this.loadData(pageIndex);
        },
        async downloadSource(item) {
            if (!this.userInfo || !this.userInfo.id) {
                this.$message.warning('请先登录！')
                this.toLogin();
                return;
            }
            if (!this.userInfo.expired) {
                this.$message.warning('你需要先购买套餐才可以下载！')
                this.showPurchaseModal();
                return;
            }
            try {
                // 显示下载提示
                const loading = this.$message({
                    message: '正在下载文件...',
                    type: 'info',
                    duration: 0,
                });

                // 使用axiosProxy中的fileStreamPost方法进行文件下载
                const response = await http.fileStreamPost('/app/jbh/downloadSource', item);

                loading.close();

                // 从响应头中获取文件名
                let fileName = item.title ? `${item.title}.psd` : 'download.psd';
                const contentDisposition = response.headers['content-disposition'];
                if (contentDisposition) {
                    const fileNameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (fileNameMatch && fileNameMatch[1]) {
                        fileName = decodeURIComponent(fileNameMatch[1].replace(/['"]/g, ''));
                    }
                }

                // 创建下载链接
                const downloadUrl = window.URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                // 清理blob URL
                window.URL.revokeObjectURL(downloadUrl);

                this.$message.success('文件下载成功！');
                console.log('文件下载成功:', fileName);
            } catch (error) {
                console.error('下载文件失败:', error);
                this.$message.error('下载文件失败: ' + (error.message || '未知错误'));
            }
        },
        handleCategoryChange(category) {
            this.currentCategory = category;
            this.reloadData();
        },
        // 处理素材类型切换
        handleMaterialTypeChange(materialType) {
            // 如果点击的是当前已选中的类型，直接返回，避免不必要的更新
            if (this.currentMaterialType.value === materialType.value) {
                return;
            }

            this.currentMaterialType = materialType;

            // 获取当前素材类型下的分类列表
            const filteredCategories = this.categoryList.filter(category =>
                category.typeCode === materialType.value
            );

            // 如果有分类，选择第一个分类并加载数据
            if (filteredCategories.length > 0) {
                this.currentCategory = filteredCategories[0];
                this.reloadData();
            } else {
                // 如果没有分类，清空当前分类和数据
                this.currentCategory = {};
                this.cardData = [];
                this.page.total = 0;
                this.page.index = 1;
            }
        },
        reloadData() {
            // 重置预加载缓存
            this.preloadedPages.clear();
            this.imageLoadingStates.clear();
            this.page.index = 1;
            this.loadData(1);
        },
        async initData() {
            await this.loadCategory();
            await this.loadData(1);
        },
        async generatePaymentQrCode() {
            this.paymentLoading = true;
            this.paymentQrCode = null;

            try {
                let params = {
                    productId: this.selectedPackageInfo.id,
                    invitationCode: this.invitationCode
                }
                let { code, data, message } = await api.createOrder(params)
                if (code === 1000) {
                    this.paymentQrCode = data.qrcode;
                    this.orderId = data.orderId
                    this.paymentLoading = false;
                    this.paymentPolling = true;
                    await this.startPaymentPolling();
                } else {
                    this.$message.error(message || '支付码获取失败,请联系管理员！')
                    this.paymentLoading = false;
                }

            } catch (error) {
                if (error.toString().indexOf('401') > -1) {
                    // 未登录时，显示登录弹窗
                    this.paymentPolling = false;
                    this.paymentModalVisible = false;
                    storage.removeToken()
                    this.toLogin();
                }
                this.paymentLoading = false;
                console.error('生成支付二维码失败:', error);
            }
        },

        async startPaymentPolling() {
            this.pollInterval = setInterval(async () => {
                try {
                    let { code, data } = await api.queryOrderStatus(this.orderId)
                    if (code === 1000) {
                        if (data.orderStatus === 2) {
                            clearInterval(this.pollInterval);
                            this.paymentPolling = false;
                            this.paymentResult = 'success';
                            // this.paymentResultVisible = true;

                            this.$message.success("购买成功！")

                            // 支付成功后刷新用户信息
                            window.location.reload();
                        } else if (data.orderStatus === 3) {
                            clearInterval(this.pollInterval);
                            this.paymentPolling = false;
                            this.paymentResult = 'failed';
                            this.paymentResultVisible = true;
                        }
                    } else {
                        this.$message.error('查询订单状态失败！');
                    }
                } catch (error) {
                    console.error('查询支付状态失败:', error);
                    clearInterval(this.pollInterval);
                    this.paymentPolling = false;
                    this.paymentResult = 'failed';
                    this.paymentResultVisible = true;
                }
            }, 2000);

            // 5分钟后停止轮询
            setTimeout(() => {
                clearInterval(this.pollInterval);
                if (this.paymentPolling) {
                    this.paymentPolling = false;
                    this.paymentResult = 'cancelled';
                    this.paymentResultVisible = true;
                }
            }, 300000);
        },
        hidePaymentModal() {
            // 清理轮询定时器
            if (this.pollInterval) {
                clearInterval(this.pollInterval);
                this.pollInterval = null;
            }

            // 如果还在轮询状态，说明是用户手动取消
            if (this.paymentPolling) {
                this.paymentPolling = false;
                this.paymentResult = 'cancelled';
                this.paymentResultVisible = true;
            }

            this.paymentModalVisible = false;
            this.paymentQrCode = null;
            this.paymentLoading = false;

            document.body.style.overflow = 'auto';
        },
        hidePaymentResult() {
            this.paymentResultVisible = false;
            this.paymentResult = null;
        },

        // ==================== 下载客户端相关方法 ====================

        /**
         * 显示下载客户端弹窗
         */
        async showDownloadModal() {
            try {
                // 获取最新版本信息
                await this.loadLatestClientVersion();
                if (!this.clientVersionInfo) {
                    this.$message.error('暂无可用客户端版本！');
                    return;
                }
                this.downloadModalVisible = true;
                document.body.style.overflow = 'hidden';
                document.addEventListener('keydown', this.handleDownloadKeyDown);
            } catch (error) {
                console.error('获取版本信息失败:', error);
                this.$message.error('获取版本信息失败，请稍后重试');
            }
        },

        /**
         * 隐藏下载客户端弹窗
         */
        hideDownloadModal() {
            this.downloadModalVisible = false;
            document.body.style.overflow = 'auto';
            document.removeEventListener('keydown', this.handleDownloadKeyDown);
        },

        /**
         * 处理下载弹窗的键盘事件
         */
        handleDownloadKeyDown(e) {
            if (e.key === 'Escape') {
                this.hideDownloadModal();
            }
        },

        /**
         * 加载最新客户端版本信息
         */
        async loadLatestClientVersion() {
            try {
                const { code, data, message } = await api.getLatestClientVersion();
                if (code === 1000) {
                    this.clientVersionInfo = data;
                } else {
                    throw new Error(message || '获取版本信息失败');
                }
            } catch (error) {
                console.error('加载版本信息失败:', error);
                throw error;
            }
        },

        /**
         * 下载客户端
         */
        async downloadClient(platform = 'windows') {
            try {
                // 1. 检查用户是否登录
                if (!this.userInfo || !this.userInfo.id) {
                    this.$message.warning('请先登录！');
                    this.hideDownloadModal();
                    this.toLogin();
                    return;
                }

                // 2. 检查用户是否为VIP会员
                if (!this.userInfo.expired) {
                    this.$message.warning('您需要购买VIP套餐才可以下载客户端！');
                    this.hideDownloadModal();
                    this.showPurchaseModal();
                    return;
                }

                // 3. 检查版本信息是否存在
                if (!this.clientVersionInfo) {
                    this.$message.error('版本信息不存在，请刷新页面重试');
                    return;
                }

                // 4. 调用后端下载接口
                const downloadParams = {
                    id: this.clientVersionInfo.id,
                    platform: platform
                };

                const { code, data, message } = await api.downloadVersion(downloadParams);

                if (code === 1000) {
                    // 使用 a 标签模拟下载，避免被浏览器拦截
                    const link = document.createElement('a');
                    link.href = data;

                    // 尝试从URL中提取文件名，或使用默认文件名
                    const urlParts = data.split('/');
                    const fileName = urlParts[urlParts.length - 1] || `虹猫简笔画客户端_${platform}.exe`;
                    link.download = decodeURIComponent(fileName);

                    // 设置为不在新窗口打开
                    link.target = '_self';

                    // 添加到DOM，触发点击，然后移除
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    // 关闭弹窗
                    this.hideDownloadModal();
                } else {
                    this.$message.error(message || '获取下载信息失败');
                }
            } catch (error) {
                console.error('下载客户端失败:', error);
                this.$message.error('下载失败: ' + (error.message || '请稍后重试'));
            }
        },


        // ==================== 工具方法 ====================

        /**
         * 格式化文件大小
         */
        formatFileSize(bytes) {
            if (!bytes) return '未知';

            const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
            if (bytes === 0) return '0 B';

            const i = Math.floor(Math.log(bytes) / Math.log(1024));
            const size = (bytes / Math.pow(1024, i)).toFixed(1);

            return `${size} ${sizes[i]}`;
        },

        /**
         * 格式化日期
         */
        formatDate(dateString) {
            if (!dateString) return '';

            try {
                const date = new Date(dateString);
                return date.toLocaleDateString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit'
                });
            } catch (error) {
                return dateString;
            }
        },

        /**
         * 获取平台名称
         */
        getPlatformName(platform) {
            const names = {
                'windows': 'Windows 版本',
                'mac': 'macOS 版本',
                'linux': 'Linux 版本'
            };
            return names[platform] || platform;
        },

        /**
         * 获取平台描述
         */
        getPlatformDesc(platform) {
            const descs = {
                'windows': '适用于 Windows 10/11',
                'mac': '适用于 macOS 10.14+',
                'linux': '适用于主流 Linux 发行版'
            };
            return descs[platform] || '';
        },

        // ==================== 图片优化相关方法 ====================

        /**
         * 获取优化后的图片URL
         */
        getOptimizedImageUrl(originalUrl, sizeType = 'thumbnail') {
            if (!originalUrl) return '';

            const config = this.imageConfig[sizeType];
            if (!config) return originalUrl;

            // 检查是否为OSS URL（简单判断，可根据实际情况调整）
            if (originalUrl.includes('aliyuncs.com') || originalUrl.includes('oss-')) {
                return `${originalUrl}?x-oss-process=image/resize,m_fill,h_${config.height},w_${config.width}/quality,q_${config.quality}`;
            }

            // 本地图片或其他CDN，返回原URL
            return originalUrl;
        },

        /**
         * 生成缩略图URL
         */
        getThumbnailUrl(originalUrl) {
            if (!originalUrl) return '';

            // 解析URL，找到最后一个点的位置（文件扩展名）
            const lastDotIndex = originalUrl.lastIndexOf('.');
            if (lastDotIndex === -1) {
                // 没有扩展名，直接返回原URL
                return originalUrl;
            }

            // 分离文件名和扩展名
            const fileNamePart = originalUrl.substring(0, lastDotIndex);
            const extensionPart = originalUrl.substring(lastDotIndex);

            // 生成缩略图URL：在扩展名前添加_thumb
            const thumbnailUrl = fileNamePart + '_thumb' + extensionPart;

            return thumbnailUrl;
        },

        /**
         * 设置图片加载状态
         */
        setImageLoadingState(itemId, state) {
            this.imageLoadingStates.set(itemId, state);
        },

        /**
         * 获取图片加载状态
         */
        getImageLoadingState(itemId) {
            return this.imageLoadingStates.get(itemId) || 'ready';
        },

        /**
         * 图片开始加载回调
         */
        onImageLoadStart(itemId) {
            this.setImageLoadingState(itemId, 'loading');
        },

        /**
         * 图片加载成功回调
         */
        onImageLoad(itemId) {
            this.setImageLoadingState(itemId, 'loaded');
        },

        /**
         * 图片加载失败回调
         */
        onImageError(itemId, event) {
            const img = event.target;
            const currentSrc = img.src;

            // 检查当前是否是缩略图URL
            if (currentSrc.includes('_thumb')) {
                // 如果是缩略图加载失败，尝试加载原图
                const originalUrl = currentSrc.replace('_thumb', '');
                console.log('缩略图加载失败，切换到原图:', originalUrl);
                img.src = originalUrl;
                return;
            }

            // 原图也加载失败，设置错误状态
            this.setImageLoadingState(itemId, 'error');
        },

        /**
         * 分类图片加载失败回调
         */
        onCategoryImageError(event, originalUrl) {
            const img = event.target;
            const currentSrc = img.src;

            // 检查当前是否是缩略图URL
            if (currentSrc.includes('_thumb')) {
                // 如果是缩略图加载失败，尝试加载原图
                console.log('分类缩略图加载失败，切换到原图:', originalUrl);
                img.src = originalUrl;
            }
        },

        /**
         * 初始化Intersection Observer
         */
        initIntersectionObserver() {
            if (typeof IntersectionObserver === 'undefined') {
                console.warn('IntersectionObserver not supported, fallback to immediate loading');
                return;
            }

            this.intersectionObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const img = entry.target;
                        // 当最后几张图片进入视口时，触发下一页预加载
                        this.preloadNextPageImages();

                        // 停止观察已进入视口的图片
                        this.intersectionObserver.unobserve(img);
                    }
                });
            }, {
                rootMargin: '200px', // 提前200px开始预加载下一页
                threshold: 0.1
            });
        },

        /**
         * 预加载下一页图片
         */
        async preloadNextPageImages() {
            const nextPage = this.page.index + 1;
            const maxPage = Math.ceil(this.page.total / this.page.limit);

            // 检查是否还有下一页且未预加载过
            if (nextPage <= maxPage && !this.preloadedPages.has(nextPage)) {
                try {
                    // 标记为已预加载，避免重复预加载
                    this.preloadedPages.add(nextPage);

                    // 使用新的loadData方法进行预加载
                    const data = await this.loadData(nextPage, true);

                    if (data && data.records) {
                        // 预加载图片
                        data.records.forEach(item => {
                            const img = new Image();
                            img.src = this.getOptimizedImageUrl(item.mainImage, 'thumbnail');
                        });
                    }
                } catch (error) {
                    console.error('预加载图片失败:', error);
                    // 预加载失败时移除标记，允许重试
                    this.preloadedPages.delete(nextPage);
                }
            }
        },

        /**
         * 观察图片元素
         */
        observeImage(img) {
            if (this.intersectionObserver && img) {
                this.intersectionObserver.observe(img);
            }
        },

        /**
         * 清理Intersection Observer
         */
        cleanupIntersectionObserver() {
            if (this.intersectionObserver) {
                this.intersectionObserver.disconnect();
                this.intersectionObserver = null;
            }
        },

        /**
         * 设置懒加载
         */
        setupLazyLoading() {
            // 现在图片直接使用src属性，浏览器原生懒加载会处理
            // 这里主要用于触发预加载机制
            this.$nextTick(() => {
                // 检查是否需要触发预加载
                const images = this.$refs.cardImage;
                if (images && images.length > 0) {
                    // 观察最后几张图片，用于触发预加载
                    const lastImages = Array.isArray(images) ? images.slice(-2) : [images];
                    lastImages.forEach(img => this.observeImage(img));
                }
            });
        }
    },
    async mounted() {
        // 初始化Intersection Observer
        this.initIntersectionObserver();

        // 页面加载时检查是否已登录
        if (this.hasLogin) {
            this.initUserInfo();
        }
        this.initData();

        // 初始化滚动按钮状态
        this.updateScrollButtons();

        // 添加窗口尺寸变化监听器
        window.addEventListener('resize', this.updateScrollButtons);
    },
    beforeDestroy() {
        document.removeEventListener('keydown', this.handleKeyDown);
        document.removeEventListener('keydown', this.handlePurchaseKeyDown);
        document.removeEventListener('keydown', this.handleDownloadKeyDown);
        document.body.style.overflow = 'auto';

        // 移除窗口尺寸变化监听器
        window.removeEventListener('resize', this.updateScrollButtons);
        this.clearTimers();

        // 清理Intersection Observer
        this.cleanupIntersectionObserver();
    }
}
</script>

<style scoped>
@import "./assets/index.css";
@import "./assets/main.css";


::v-deep .el-pagination>button {
    background-color: #f4f4f500 !important;
    width: 36px;
    height: 36px;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: rgba(123, 245, 202, 1) !important;
    color: #000 !important;
}

::v-deep .el-pagination__total {
    height: 36px !important;
    line-height: 36px !important;
}

::v-deep .el-pagination .el-select .el-input {
    width: 110px;
}

::v-deep .el-pagination .el-select .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-radius: 8px;
}

::v-deep .el-pagination .el-pagination__jump {
    height: 36px;
    line-height: 36px;
}

::v-deep .el-pagination .el-pagination__jump .el-input__inner {
    height: 36px;
    line-height: 36px;
    border-radius: 8px;
    width: 50px;
}

/* 加载状态样式 */
.loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid #f3f3f3;
    border-top: 3px solid #7bf5ca;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.loading-container p {
    color: #666;
    font-size: 14px;
    margin: 0;
}

/* 错误状态样式 */
.error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
}

.error-icon {
    margin-bottom: 16px;
    color: #f56c6c;
}

.error-container p {
    color: #666;
    font-size: 14px;
    margin: 0 0 16px 0;
}

.retry-btn {
    background: #7bf5ca;
    color: #000;
    border: none;
    padding: 8px 16px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    transition: background-color 0.3s;
}

.retry-btn:hover {
    background: #5de8b8;
}

/* ==================== 图片优化样式 ==================== */

/* 图片容器相对定位 */
.card-image-wrapper {
    position: relative;
    overflow: hidden;
}

/* 图片占位符样式 */
.image-placeholder {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
}

/* 闪烁加载动画 */
.placeholder-shimmer {
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%);
    background-size: 200% 100%;
    animation: shimmer 2s infinite;
}

@keyframes shimmer {
    0% {
        background-position: -200% 0;
    }

    100% {
        background-position: 200% 0;
    }
}

/* 图片加载失败样式 */
.image-error {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: #f8f8f8;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 12px;
    z-index: 1;
}

.image-error svg {
    margin-bottom: 8px;
    color: #ccc;
}

.image-error p {
    margin: 0;
    font-size: 12px;
}

/* 图片加载完成后的过渡效果 */
.card-image {
    transition: opacity 0.3s ease-in-out;
    opacity: 1;
    /* 默认显示图片 */
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.card-image.loaded {
    opacity: 1;
}

/* 弹窗图片样式 */
.modal-image {
    max-width: 100%;
    max-height: 80vh;
    object-fit: contain;
}

/* 分类图标优化 */
.category-avatar {
    transition: opacity 0.3s ease-in-out;
}

/* ==================== 下载客户端样式 ==================== */

/* 下载客户端按钮区域 */
.download-client-section {
    margin-right: 16px;
}

.download-client-btn {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    background: linear-gradient(135deg, #7bf5ca 0%, #5de8b8 100%);
    color: #000;
    border: none;
    border-radius: 6px;
    cursor: pointer;
    font-size: 12px;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 1px 4px rgba(123, 245, 202, 0.3);
}

.download-client-btn:hover {
    background: linear-gradient(135deg, #5de8b8 0%, #4dd9a7 100%);
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(123, 245, 202, 0.4);
}

.download-client-btn svg {
    flex-shrink: 0;
}

.download-client-btn span {
    white-space: nowrap;
}

/* 下载弹窗样式 */
.download-modal-enter-active,
.download-modal-leave-active {
    transition: all 0.3s ease;
}

.download-modal-enter,
.download-modal-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.download-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    backdrop-filter: blur(4px);
}

.download-modal-container {
    background: white;
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
    max-width: 600px;
    width: 90%;
    max-height: 80vh;
    overflow: hidden;
    position: relative;
}

/* 弹窗头部 */
.download-modal-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 24px 24px 16px;
    border-bottom: 1px solid #f0f0f0;
}

.download-modal-title-section {
    flex: 1;
}

.download-modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 4px 0;
}

.download-modal-subtitle {
    font-size: 14px;
    color: #7f8c8d;
    margin: 0;
    line-height: 1.5;
}

.download-modal-close {
    width: 32px;
    height: 32px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    color: #7f8c8d;
    transition: all 0.2s ease;
    margin-left: 16px;
}

.download-modal-close:hover {
    background: #f8f9fa;
    color: #2c3e50;
}

/* 弹窗内容 */
.download-modal-content {
    padding: 24px;
    max-height: 60vh;
    overflow-y: auto;
}

/* 客户端特性 */
.client-features {
    margin-bottom: 32px;
}

.feature-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 0;
    border-bottom: 1px solid #f8f9fa;
}

.feature-item:last-child {
    border-bottom: none;
}

.feature-icon {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: linear-gradient(135deg, #7bf5ca 0%, #5de8b8 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #000;
    flex-shrink: 0;
}

.feature-text h4 {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 4px 0;
}

.feature-text p {
    font-size: 14px;
    color: #7f8c8d;
    margin: 0;
    line-height: 1.5;
}

/* 下载选项 */
.download-options {
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.download-option {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    border: 2px solid #f0f0f0;
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: white;
}

.download-option:hover {
    border-color: #7bf5ca;
    background: linear-gradient(135deg, rgba(123, 245, 202, 0.05) 0%, rgba(93, 232, 184, 0.05) 100%);
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(123, 245, 202, 0.2);
}

.option-icon {
    width: 44px;
    height: 44px;
    border-radius: 10px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #495057;
    flex-shrink: 0;
}

.download-option:hover .option-icon {
    background: linear-gradient(135deg, #7bf5ca 0%, #5de8b8 100%);
    color: #000;
}

.option-info {
    flex: 1;
    min-width: 0;
}

.option-info h3 {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 2px 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.option-info p {
    font-size: 13px;
    color: #7f8c8d;
    margin: 0;
    line-height: 1.4;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.download-arrow {
    color: #7f8c8d;
    transition: all 0.3s ease;
    flex-shrink: 0;
}

.download-option:hover .download-arrow {
    color: #2c3e50;
    transform: translateX(4px);
}

/* 版本信息 */
.version-info {
    padding: 16px;
    background: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 16px;
}

.version-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 32px;
}

.version-item {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.version-label {
    font-size: 12px;
    color: #7f8c8d;
    font-weight: 500;
}

.version-value {
    font-size: 14px;
    color: #2c3e50;
    font-weight: 600;
}


/* 更新说明 */
.changelog-section {
    margin-top: 16px;
}

.changelog-section h4 {
    font-size: 16px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0 0 12px 0;
}

.changelog-content {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 16px;
    font-size: 14px;
    line-height: 1.6;
    color: #495057;
    border-left: 4px solid #7bf5ca;
}

.changelog-content p {
    margin: 0 0 8px 0;
}

.changelog-content p:last-child {
    margin-bottom: 0;
}

.changelog-content ul,
.changelog-content ol {
    margin: 8px 0;
    padding-left: 20px;
}

.changelog-content li {
    margin: 4px 0;
}

/* ==================== 素材类型筛选器样式 ==================== */

/* 联合导航栏容器 */
.combined-nav {
    display: flex;
    align-items: center;
    gap: 16px;
}

/* 素材类型导航栏 */
.material-type-nav {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 8px;
    width: 180px;
    flex-shrink: 0;
    align-content: center;
}

.material-type-nav::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari, Opera */
}

/* 素材类型项 */
.material-type-item {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 8px 12px;
    background: #f8f9fa;
    border: 1px solid #e9ecef;
    border-radius: 16px;
    cursor: pointer;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 500;
    color: #6c757d;
    min-height: 36px;
    width: 80px;
}

.material-type-item:hover:not(.active) {
    background: #e9ecef;
    border-color: #dee2e6;
    color: #495057;
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.material-type-item.active {
    background: linear-gradient(135deg, #7bf5ca 0%, #5de8b8 100%) !important;
    border-color: #7bf5ca !important;
    color: #000 !important;
    font-weight: 600;
    box-shadow: 0 2px 12px rgba(123, 245, 202, 0.3);
}

.material-type-item.active:hover {
    background: linear-gradient(135deg, #5de8b8 0%, #4dd9a7 100%) !important;
    transform: translateY(-1px);
    box-shadow: 0 4px 16px rgba(123, 245, 202, 0.4);
}

/* 素材类型图标 */
.material-type-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    flex-shrink: 0;
}

.material-type-icon i {
    font-size: 18px;
}

.material-type-item.active .material-type-icon i {
    color: #000;
}

/* 素材类型标签 */
.material-type-label {
    font-size: inherit;
    font-weight: inherit;
    color: inherit;
}

/* ========== 分类滚动样式 ========== */
.category-nav-wrapper {
    position: relative;
    flex: 1;
    display: flex;
    align-items: center;
    gap: 16px;
    margin-left: 16px;
    width: 100%;
    min-width: 0;
    overflow: hidden;
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.combined-nav .category-nav {
    flex: 1;
    display: flex;
    padding: 0;
    overflow-x: auto;
    scroll-behavior: smooth;
    scrollbar-width: none;
    -ms-overflow-style: none;
    white-space: nowrap;
    cursor: grab;
    width: 0;
    /* 强制flex子元素收缩 */
    min-width: 0;
}

.combined-nav .category-nav::-webkit-scrollbar {
    display: none;
}

.combined-nav .category-nav:active {
    cursor: grabbing;
}

.scroll-btn {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.6);
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 20;
    flex-shrink: 0;
}

.scroll-btn:hover {
    color: rgba(255, 255, 255, 1);
    transform: scale(1.1);
}

.scroll-btn.disabled {
    opacity: 0.3;
    cursor: not-allowed;
    transform: none;
}

.scroll-btn.disabled:hover {
    color: rgba(255, 255, 255, 0.6);
    transform: none;
}

/* 导航按钮样式 - 参考素材中心实现 */
.category-nav-button {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);
    z-index: 20;
    flex-shrink: 0;
    position: relative;
}

.category-nav-button:hover {
    background: rgba(255, 255, 255, 0.15);
    color: rgba(255, 255, 255, 1);
    transform: scale(1.05);
}

.category-nav-button.swiper-button-disabled {
    opacity: 0.3;
    cursor: not-allowed;
    transform: none;
}

.category-nav-button.swiper-button-disabled:hover {
    background: rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.8);
    transform: none;
}

/* ========== Swiper 样式覆盖 ========== */
/* 隐藏默认的 Swiper 导航按钮 */
:deep(.swiper-button-prev),
:deep(.swiper-button-next) {
    display: none;
}

/* 确保 Swiper 容器正确使用可用空间 */
:deep(.swiper) {
    width: 100%;
    overflow: hidden;
    height: auto;
}

:deep(.swiper-wrapper) {
    display: flex !important;
    flex-direction: row !important;
    align-items: center;
    width: 100%;
    height: auto;
}

:deep(.swiper-slide) {
    width: auto !important;
    height: auto !important;
    flex-shrink: 0;
    margin-right: 0 !important;
    display: flex;
    justify-content: center;
}

/* ========== 分类项样式 ========== */
.category-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    cursor: pointer;
    transition: all 0.3s ease;
    min-width: 90px;
    padding: 8px;
}

.category-item:hover {
    transform: translateY(-5px);
}

.category-item.active {
    transform: scale(1.1);
}

.category-avatar {
    width: 90px;
    height: 90px;
    border-radius: 50%;
    object-fit: cover;
    border: 3px solid transparent;
    transition: border-color 0.3s ease;
    background: #9e9e9e24;
}

.category-item.active .category-avatar {
    border-color: #7BF5CA;
    box-shadow: 0 0 20px rgba(123, 245, 202, 0.5);
}

.category-label {
    color: rgba(255, 255, 255, 0.85);
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    white-space: normal;
    word-wrap: break-word;
    overflow-wrap: break-word;
    line-height: 1.2;
    max-width: 100%;
    transition: color 0.3s ease;
}

.category-item.active .category-label {
    color: #7BF5CA;
    font-weight: 600;
}


/* 响应式设计 */
@media (max-width: 768px) {
    .combined-nav {
        flex-direction: column;
        gap: 12px;
        padding: 12px 0;
    }

    .material-type-nav {
        width: auto;
        gap: 6px;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
    }

    .category-swiper-container {
        margin-left: 12px;
        gap: 12px;
    }

    .category-nav-button {
        width: 36px;
        height: 36px;
    }

    .category-slide {
        max-width: 110px;
    }

    .category-item {
        min-width: 80px;
        padding: 8px;
    }

    .category-avatar {
        width: 70px;
        height: 70px;
    }

    .category-label {
        font-size: 12px;
    }

    .material-type-item {
        padding: 6px 8px;
        font-size: 12px;
        gap: 4px;
        min-height: 32px;
    }

    .material-type-icon {
        width: 14px;
        height: 14px;
    }

    .material-type-icon i {
        font-size: 14px;
    }

    /* 在小屏幕上保留文字 */
    .material-type-label {
        font-size: 12px;
    }
}

@media (max-width: 480px) {
    .combined-nav {
        padding: 8px 0;
        gap: 8px;
    }

    .material-type-nav {
        gap: 4px;
        grid-template-columns: 1fr 1fr;
        grid-template-rows: 1fr 1fr;
    }

    .category-swiper-container {
        margin-left: 8px;
        gap: 8px;
    }

    .category-nav-button {
        width: 32px;
        height: 32px;
    }

    .category-slide {
        max-width: 90px;
    }

    .category-item {
        min-width: 70px;
        padding: 6px;
    }

    .category-avatar {
        width: 60px;
        height: 60px;
    }

    .category-label {
        font-size: 11px;
    }

    .material-type-item {
        padding: 4px 6px;
        font-size: 11px;
        gap: 2px;
        min-height: 28px;
        border-radius: 12px;
    }

    .material-type-icon {
        width: 12px;
        height: 12px;
    }

    .material-type-icon i {
        font-size: 12px;
    }

    .material-type-label {
        font-size: 11px;
    }
}

/* 响应式设计 */
@media (max-width: 768px) {
    .download-client-btn span {
        display: none;
    }

    .download-client-btn {
        padding: 6px;
        width: 32px;
        height: 32px;
        justify-content: center;
    }

    .download-modal-container {
        width: 95%;
        margin: 20px;
    }

    .download-modal-header {
        padding: 20px 20px 12px;
    }

    .download-modal-content {
        padding: 20px;
    }

    .feature-item {
        gap: 12px;
    }

    .feature-icon {
        width: 40px;
        height: 40px;
    }

    .option-icon {
        width: 48px;
        height: 48px;
    }

    .version-row {
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
    }

    .install-instructions {
        margin-top: 12px;
        padding: 10px 12px;
    }

    .install-text {
        font-size: 12px;
    }
}
</style>